import CardModifier from './CardModifier';
import GameObject from '../../../../GameObject/GameObject';
import Sprite from '../../../Sprite';
import Point from '../../../../Utility/Point';

export default class RisingModifier extends CardModifier {
    onCreate(params: any): void {
        super.onCreate(params);

        const risingSprite = GameObject.Instantiate(Sprite, {
            name: 'risingSprite',
            texture: 'cards_rising',
            anchor: new Point(0.5, 0.5),
        });

        this.addChild(risingSprite);
    }
}
